namespace Ir.Components.Mapping.SelectMappingPopover {

    interface ISelectMappingPopoverViewModel {
        popoverConfig: DevExpress.ui.dxPopover.Properties;
        popoverComponent: DevExpress.ui.dxPopover;

        listConfig: DevExpress.ui.dxList.Properties;
        listComponent: DevExpress.ui.dxList;
    }

    interface ISelectMappingPopoverParams {
        callback: Function;
        onMappingClick: (id: number, name: string) => void;
        position: DevExpress.PositionConfig;
    }

    export function getViewModel(this: ISelectMappingPopoverViewModel, params: ISelectMappingPopoverParams) {
        this.listConfig = {
            keyExpr: 'id',
            displayExpr: 'displayName',
            searchEnabled: true,
            searchExpr: 'displayName',
            pageLoadMode: 'scrollBottom',
            onInitialized: function (this: ISelectMappingPopoverViewModel, e) {
                this.listComponent = e.component;
            },
            onItemClick: function (this: ISelectMappingPopoverViewModel, e) {
                params.onMappingClick(e.itemData.id, e.itemData.displayName);
                this.popoverComponent.hide();
            }.bind(this),
            noDataText: "No mappings allowed"
        };

        this.popoverConfig = {
            title: "Mapping selection",
            showTitle: true,
            position: params.position ? params.position : "right",
            width: 300,
            visible: false,
            onShowing(e) {
                loadDataSource.call(this);
            },
            onInitialized: function (this: ISelectMappingPopoverViewModel, e) {
                this.popoverComponent = e.component;
                if (params.callback && typeof params.callback === "function") {
                    params.callback({
                        show: function (this: ISelectMappingPopoverViewModel, element) {
                            this.popoverComponent.show(element);
                        }.bind(this)
                    });
                }
            }.bind(this)
        };
    }

    function loadDataSource(this: ISelectMappingPopoverViewModel) {
        let self = this;
        let o = {
            url: urlConfigs.tabs + "GetMappingsCreateWorkbook",
            data: { },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result, e) {
            self.listComponent.option("dataSource", result);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get mappings";
            self.listComponent.option("dataSource", []);
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
}